import { AbsenceListResponse, AbsenceResponseItem } from '@/types/service-response'
import { AbsenceListFilterValue } from '@/types/payload'
import { AbsencesFilterScope } from '@/types/enums'
import moment from 'moment'

export class Absence {
  private constructor (
    readonly id: number,
    readonly MRAID: number,
    readonly profitCenterId: number,
    readonly departmentId: number,
    //readonly planningGroupId: number,
    readonly employeeId: number,
    readonly employeeName: string,
    readonly start: Date,
    readonly end: Date,
    //readonly days: number,
    readonly reason: number,
    readonly comment: string,
    readonly requestApproved: boolean,
    readonly requestDisapproved: boolean,
    //readonly requestStatusRemarks: string,
    readonly basicName: string,
    //readonly isBlockAppointment: boolean,
    //readonly deleted: boolean,
    readonly medicalCertificate: boolean,
    readonly medicalCertificateValid: Date | undefined,
    readonly department: number,
    //readonly language: number,
    readonly isRepeating: boolean,
    readonly serieId: number,
    public show: boolean,
    readonly who: number,
    readonly whoApproved: number,
    readonly color?: string
  ) {}

  public satisfiesConditions (filter: AbsenceListFilterValue): boolean {
    const textList: string[] = filter.text.split(/[|,&]/)
    let conditions: Array<boolean> = []
    let textConditions: Array<boolean> = []

    textList.forEach((item: string) => {
      textConditions.push(`${moment(this.start).format('DD.MM.YYYY')} ${this.basicName} ${this.employeeName}`.toLocaleLowerCase().includes(item.toLocaleLowerCase()))
    })

    if(textConditions.length > 0) {
      conditions.push(textConditions.some(v => v))
    } else {
      conditions.push(true)
    }

    if (filter.scope !== AbsencesFilterScope.AllAbsences) {
      if (filter.scope === AbsencesFilterScope.ApprovedAbsencesFalse) {
        conditions.push(!this.requestApproved && !this.requestDisapproved)
      } else if (filter.scope === AbsencesFilterScope.ApprovedAbsencesTrue) {
        conditions.push(this.requestApproved)
      }else if (filter.scope === AbsencesFilterScope.DisapprovedAbsences) {
        conditions.push(this.requestDisapproved)
      }
    }

    return conditions.every(v => v)
  }

  public static createListFromResponse (data: AbsenceListResponse): Array<Absence> {
    const list: Array<Absence> = data.map((item: AbsenceResponseItem) => {
      let certificateValid: Date | undefined = undefined
      if (item.Arztzeugnis_GueltigBis !== null) {
        certificateValid = item.Arztzeugnis_GueltigBis
      } else {
        certificateValid = undefined
      }

      return new Absence(
        item.ID,
        item.MRAID,
        item.ProfitCenter,
        item.Abteilungen,
        //parseInt(item.PlanungsgruppeID),
        item.MitarbeiterID,
        item.MitabeiterName,
        item.DatumVon,
        item.DatumBis,
        //item.Tage,
        item.Grund,
        item.Bemerkung,
        item.RequestApproved,
        item.RequestDisapproved,
        //item.RequestStatusBemerkungen,
        item.GrundBezeichnung,
        //item.IsBlockAppointment,
        //item.Geloescht,
        item.Arztzeugnis,
        certificateValid,
        item.Abteilungen,
        //item.Sprache,
        !item.Einmalig,
        item.SerienID,
        item.Show,
        item.Who,
        item.WhoApproved,
        item.Color
      )
    })

    return list
  }
}
